module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/step2-2982d95ada2e3b87c32977f24a7cdc47.jpg";